// extracted by mini-css-extract-plugin
module.exports = {"root":"RatingRow_root__b8o4K","label":"RatingRow_label__1opGz","value":"RatingRow_value__1I5qX"};